const DEFAULT_SUGGESTIONS = {
  content: "Content is insufficient. Try to add more relevant details to improve the score.",
  pronunciation: "Pronunciation needs improvement.\nPractice enunciating words more clearly.",
  fluency: "Fluency is lacking. Try to speak more smoothly without long pauses.",
  appropriacy: "Appropriacy needs improvement. Make sure your answer fits the situation.",
};

const normalizeSuggestion = (value) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean).join("\n");
  }

  if (typeof value === "string" && value.trim()) {
    return value;
  }

  return "";
};

export const getSpeakingSuggestion = (score = {}, skill, fallback) => {
  const structured = normalizeSuggestion(score?.feedback?.[skill]);
  if (structured) {
    return structured;
  }

  const legacy = normalizeSuggestion(score?.comments);
  if (legacy && skill === "fluency") {
    return legacy;
  }

  return fallback || DEFAULT_SUGGESTIONS[skill] || "";
};
